<template>
  <div class="container_cm">
    <div class="main_cm">
      <div class="bh_cm">

        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/guidance' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资料管理</el-breadcrumb-item>
          <el-breadcrumb-item>申请管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="top_cm">

        <div>
          <div style="display: flex;flex-wrap: wrap;">
            <template v-if="activeName == 'second'">

              <div>
                <span>项目名称 </span><el-input maxlength="50" v-model="searchForm.projectName" clearable
                  placeholder="请输入项目名称"></el-input>
              </div>
            </template>
            <template v-if="activeName == 'first'">
              <div>
                <span>仪器名称</span><el-input maxlength="50" v-model="searchForm.instrumentName" clearable
                  placeholder="请输入仪器名称"></el-input>
              </div>
              <div>
                <span>仪器编号</span><el-input maxlength="50" v-model="searchForm.serialNumber" clearable
                  placeholder="请输入仪器编号"></el-input>
              </div>
            </template>

            <div>
              <span>申请人</span><el-input maxlength="50" v-model="searchForm.userName" clearable
                placeholder="请输入申请人"></el-input>
            </div>
            <div>
              <span>状态</span><el-select v-model="searchForm.states" clearable placeholder="请选择状态">
                <el-option v-for="item in activeName == 'first' ? applyForInstrument : applicationForm" :key="item.key"
                  :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </div>
            <div>
              <span>是否逾期</span><el-select v-model="searchForm.isOverdue" clearable placeholder="请选择是否逾期">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </div>
            <div :style="{ marginTop: activeName == 'second' ? '' : '10px' }">
              <span>仓库名称</span><el-select v-model="searchForm.depotId" clearable placeholder="请选择仓库">
                <el-option v-for="item in depotLst" :key="item.id" :label="item.depotName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;" v-if="activeName == 'second'">
              <span>使用类型</span><el-select v-model="searchForm.useType" clearable placeholder="请选择使用类型">
                <el-option v-for="item in useTypeLst" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

      </div>
      <div class="right-but">
        <el-button class="mybtny" v-waves icon="el-icon-search" @click="toSearch">搜索</el-button>
        <el-button v-if="activeName == 'first'" class="mybtny" v-waves icon="el-icon-search"
          @click="derive">导出</el-button>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">

        <el-tab-pane label="申请仪器" name="first">
          <Table :tabelHeight="highestPort" ref="multipleTable" v-loading="loading" :tableData="List"
            :pageSize='pageSize' :currentPage="pageIndex" :cloumns="cloumns" :totalNum="total" :pageFlag='true'
            :selection='false' @handleCurrentChange="handleCurrentChange">
            <el-table-column type="index" label="编号" width="100" align="center">
            </el-table-column>
            <el-table-column prop="instrumentName" align="center" width="150" label="仪器名称">
            </el-table-column>
            <el-table-column prop="serialNumber" label="仪器编号" width="150" align="center">
            </el-table-column>
            <el-table-column prop="userName" align="center" label="申请人">
            </el-table-column>
            <el-table-column prop="depotName" label="仓库名称" width="200" align="center">
            </el-table-column>
            <el-table-column label="是否线下交接" align="center" width="180">
              <template slot-scope="scope">{{ scope.row.receiveType == 2 ? '是' : '否' }}</template>
            </el-table-column>
            <el-table-column label="预约时间" align="center" width="180">
              <template slot-scope="scope">{{ scope.row.startTime }}</template>
            </el-table-column>
            <el-table-column label="结束时间" align="center" width="180">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.endTime }}</span>
                  <el-tooltip placement="top">
                    <div slot="content">
                      原预计归还时间
                      <br />
                      <ul>
                        <li v-for="item, index in scope.row.endTimeList" :key="index" style="margin: 5px 0;">{{ item }}
                        </li>
                      </ul>
                    </div>
                    <i class="el-icon-warning-outline" style="color: orange;" v-if="scope.row.endTimeList"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="isOverdue" label="是否逾期" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.isOverdue">
                  是<div class="box-item-y"></div>
                </span>
                <span v-else>
                  否<div class="box-item-n"></div>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="位置" width="100">

            </el-table-column>
            <el-table-column prop="states" label="状态" align="center">

              <template slot-scope="{row}">
                <span> {{ row.status | statusName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="deviceType" label="仪器类型" align="center">
              <template slot-scope="{row}">
                <!-- 优化申请单仪器位置(仪器类型：入柜、扫码、固定式、智能电源) -->
                {{ row.deviceType == 1 ? '入柜' : row.deviceType == 2 ? '扫码' : row.deviceType == 3 ? '固定式' : '智能电源' }}
              </template>
            </el-table-column>
            <el-table-column prop="isNeedPower" label="是否需要充电" align="center">
              <template slot-scope="{row}">
                {{ row.isNeedPower == 1 ? '需要' : '不需要' }}
              </template>
            </el-table-column>
            <el-table-column prop="projectName" label="项目名称" width="300" align="center">
            </el-table-column>
            <!-- <el-table-column prop="receiveType" label="领取方式" align="center">
              <template slot-scope="{row}">
                {{ row.deviceType == 1 ? '二维码' : row.deviceType == 2 ? '线下交接' : '扫码' }}
              </template>
            </el-table-column> -->

            <el-table-column prop="lendOpenTime" label="借出开柜时间" width="150" align="center">
            </el-table-column>

            <el-table-column prop="lendCloseTime" label="借出关柜时间" width="150" align="center">
            </el-table-column>

            <el-table-column prop="returnOpenTime" label="归还开柜时间" width="150" align="center">
            </el-table-column>
            <el-table-column prop="returnCloseTime" label="归还关柜时间" width="150" align="center">
            </el-table-column>
            <el-table-column prop="returnPhotoUrl" label="入库照片" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.returnPhotoUrl" class="block">
                  <el-image style="width: 60px; height: 60px" :src="scope.row.returnPhotoUrl"
                    :preview-src-list="[scope.row.returnPhotoUrl]">
                  </el-image>
                </div>
                <div v-else>
                  <el-avatar src="https://empty" shape="square">
                    <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
                  </el-avatar>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" align="center" width="150">
              <template slot-scope="{row}">
                <el-button @click="exportInfo2(row)" type="text">
                  使用记录
                </el-button>
                <el-button @click="takeOutAndReturn('QC', row.id, row.hasUsingInfo)" v-if="row.status == 5" size="small"
                  type="text">取出</el-button>
                <el-button @click="takeOutAndReturn('GH', row.id, row.hasUsingInfo)" v-if="row.status == 6" size="small"
                  type="text">归还</el-button>
              </template>
            </el-table-column>
          </Table>
        </el-tab-pane>
        <el-tab-pane label="申请单" name="second">
          <Table :tabelHeight="highestPort" ref="multipleTable" v-loading="loading" :tableData="List"
            :pageSize='pageSize' :currentPage="pageIndex" :cloumns="cloumns" :totalNum="total" :pageFlag='true'
            :selection='false' @handleCurrentChange="handleCurrentChange">
            <el-table-column type="index" label="编号" width="100" align="center">
            </el-table-column>
            <el-table-column prop="projectName" label="项目名称">
            </el-table-column>
            <el-table-column prop="useType" label="使用类型">
              <template slot-scope="scope">{{ scope.row.useType==1?'项目':scope.row.useType==2?'保养':scope.row.useType==3?'检定校准':scope.row.useType==4?'维修':'/' }}</template>
            </el-table-column>
            
            <el-table-column prop="userName" align="center" width="120" label="申请人">
            </el-table-column>
            <el-table-column prop="depotName" width="120" label="仓库名称" align="center">
            </el-table-column>
            <el-table-column label="预约时间" align="center" width="180">
              <template slot-scope="scope">{{ scope.row.startTime }}</template>
            </el-table-column>
            <el-table-column label="结束时间" align="center" width="180">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.endTime }}</span>
                  <el-tooltip placement="top">
                    <div slot="content">
                      原预计归还时间
                      <br />
                      <ul>
                        <li v-for="item, index in scope.row.endTimeList" :key="index" style="margin: 5px 0;">{{ item }}
                        </li>
                      </ul>
                    </div>
                    <i class="el-icon-warning-outline" style="color: orange;" v-if="scope.row.endTimeList"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="200" align="center">
            </el-table-column>
            <el-table-column label="仪器单" width="120" align="center">
              <template slot-scope="scope">
                <el-button icon="el-icon-edit" @click="eqList(scope.row)" type="success" size="mini">仪器单</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="isOverdue" label="是否逾期" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.isOverdue">
                  是<div class="box-item-y"></div>
                </span>
                <span v-else>
                  否<div class="box-item-n"></div>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="states" label="状态" width="100" align="center">
              <template slot-scope="scope">
                <span> {{ scope.row.states | statesName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button @click="exportInfo(scope.row)" type="primary" size="mini">
                  <i style="font-size: 12px;" class="iconfont icon-wendang"></i>
                  出入库记录
                </el-button>
                <el-button v-if="scope.row.states != 7" @click="remove(scope.row)" type="danger" size="mini">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </Table>
        </el-tab-pane>
      </el-tabs>

    </div>

    <!-- 仪器单 -->
    <el-dialog title="仪器单" center :visible.sync="eqVisible" width="65%" v-if="eqVisible">
      <eqList @refresh="eqListRefresh" :eqData='eqData'></eqList>
    </el-dialog>

    <!-- 出入库导出弹框 -->
    <el-dialog title="" center :visible.sync="exPosp" width="1500px" v-if="exPosp" append-to-body>
      <exportModel :use-id="useId" :deviceType="deviceType" :instrumentId="instrumentId"></exportModel>
    </el-dialog>
    <!-- 出入库导出弹框 -->
    <el-dialog title="" center :visible.sync="exPospv2" width="1500px" v-if="exPospv2" append-to-body>
      <exportModelv2 :use-id="useId" :deviceType="deviceType" :instrumentId="instrumentId"></exportModelv2>
    </el-dialog>
    <!-- 批量导出弹框 -->
    <el-dialog title="" center :visible.sync="massExPosp" width="400px" v-if="massExPosp">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="项目名称" prop="projectId">
          <el-select v-model="ruleForm.projectId" clearable placeholder="请选择仓库">
            <el-option v-for="item in proList" :key="item.id" :label="item.projectName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓库名称" prop="depotId">
          <el-select v-model="ruleForm.depotId" clearable placeholder="请选择仓库">
            <el-option v-for="item in depotLst" :key="item.id" :label="item.depotName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间" prop="startTime">
          <el-date-picker v-model="ruleForm.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker v-model="ruleForm.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 管理员填写时间 -->
    <el-dialog title="取出/归还时间" :visible.sync="centerDialogVisible" width="400px" center>
      <el-date-picker v-model="curTime" :clearable="false" type="datetime" placeholder="选择日期时间">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getAppList, getAppListv2, exAppList, getProject, returnIns, takeOutIns } from "@/api/dataMana.js";
import eqList from "./components/eqList.vue";
import exportModel from "./components/exportModel";
import exportModelv2 from "./components/exportModelv2";
import Table from "@/components/myTable";
import { getDepotInfo, removeApply2 } from "@/api/depotApi";
import { formatDate } from '@/util/util.js'
export default {
  inject: ['reload'],
  components: {
    eqList,
    exportModel,
    exportModelv2,
    Table,
  },

  filters: {
    statesName(value) {
      let obj = {
        '-1': "待审核",
        '1': "未领用",
        '2': "取消预约",
        '3': "使用中",
        '4': "使用中",
        '5': "使用中",
        '6': "使用中",
        '7': "使用结束",
        '8': "已驳回"
      }
      return obj[value]
    },
    statusName(value) {
      let obj = {
        1: "待审核",
        2: "已驳回",
        3: "待通过",
        4: "拒绝",
        5: "待领用",
        6: "使用中",
        7: "完成"
      }
      return obj[value]

    }
  },
  data() {
    return {
      curId: null,
      visibleState: '',
      centerDialogVisible: false,
      curTime: null,
      visible: false,
      activeName: 'first',
      iconArrow: false,
      depotLst: [],
      userInfo: '',
      List: [],
      cloumns: [],
      loading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      eqData: "", // 仪器列表
      eqVisible: false,
      useTypeLst:[
      { key: 1, value: "项目" },
        { key: 2, value: "保养" },
        { key: 3, value: "检定校准" },
        { key: 4, value: "维修" },
      ],
      // 申请仪器
      applyForInstrument: [
        { key: 1, value: "待审核" },
        { key: 2, value: "已驳回" },
        { key: 3, value: "待通过" },
        { key: 4, value: "拒绝" },
        { key: 5, value: "待领用" },
        { key: 6, value: "使用中" },
        { key: 7, value: "完成" },
      ],
      applicationForm: [
        { key: -1, value: "待审核" },
        { key: 1, value: "未领用" },
        { key: 3, value: "使用中" },
        { key: 7, value: "使用结束" },
        { key: 8, value: "已驳回" }



        //待审核(-1)：-1,未领用(1):1,使用中(3):3、4、5、6,使用结束(7):7,已驳回(8):8



      ],
      searchForm: {},
      exPosp: false,
      exPospv2: false,
      useId: "",
      proList: [],
      hasUsingInfo: null,
      massExPosp: false,
      imagesDialogVisible: false,
      images: '',
      instrumentId: null,
      deviceType: null,
      ruleForm: {
        states: null,
        projectId: null,
        startTime: null,
        endTime: null,
        depotId: null,
        instrumentName: null,
        serialNumber: null,
        useType:null,
      },
      rules: {
        projectId: [
          { required: true, message: '请选择项目', trigger: 'change' },
        ],
        depotId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        startTime: [
          { type: 'string', required: true, message: '请选择时间', trigger: 'change' }
        ],
        endTime: [
          { type: 'string', required: true, message: '请选择时间', trigger: 'change' }
        ]
      }

    }
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
    this.depostInfo()
    this.getProjectList()
  },
  mounted() {
    if (this.$route.query.IsOverdue) {
      this.$set(
        this.searchForm,
        "IsOverdue",
        parseInt(this.$route.query.IsOverdue)
      );
    }
    this.getAppInfo();
  },
  methods: {
    remove(data) {
      this.$confirm('是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeApply2(data.id)
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功！");
              this.getAppInfo();
            } else {
              this.$message.error(res.msg || "服务器连接失败");
            }
          })
          .catch((err) => {
            this.$message.error(err.msg || err.message || "服务器连接失败");
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    takeOutAndReturn(value, id, hasUsingInfo) {
      if (hasUsingInfo != 1 && value == 'GH') {
        this.$message.success("该仪器未填写使用记录！");
        return
      }
      this.curId = id
      this.visibleState = value,
        this.hasUsingInfo = hasUsingInfo
      this.centerDialogVisible = true
      this.curTime = new Date()
    },
    submit() {
      if (this.visibleState == 'QC') {
        let self = this;
        takeOutIns({
          id: self.curId,
          lendTime: formatDate(self.curTime, 'all')
        }).then(res => {
          if (res.code == '200') {
            self.$message.success(res.msg || res.message || "取出成功！");
            this.centerDialogVisible = false
            self.getAppInfo();
          } else {
            self.$message.error(res.msg);
          }
        }).catch(err => {
          self.$message.error(err.msg || err.message || "服务器连接失败");
        })
      }
      if (this.visibleState == 'GH') {
        let self = this;
        returnIns({
          id: self.curId,
          returnTime: formatDate(self.curTime, 'all')
        }).then(res => {
          if (res.code == '200') {
            self.$message.success(res.msg || res.message || "归还成功！");
            this.centerDialogVisible = false
            self.getAppInfo();
          } else {
            self.$message.error(res.msg);
          }
        }).catch(err => {
          self.$message.error(err.msg || err.message || "服务器连接失败");
        })
      }

    },
    handleConfirm(row) {
      this.$refs['popover' + row.id].doClose();
    },
    //图片预览
    preview(images) {
      this.images = images
      this.imagesDialogVisible = true
    },

    // 获取项目列表
    getProjectList() {
      let params = {
        deptId: this.userInfo.deptId,
        current: 1,
        size: 100,
      };
      getProject(params)
        .then((res) => {
          if (res.code == "200") {
            this.proList = res.data.records;
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg || "服务器连接失败");
          }
        })
        .catch((err) => {
          this.$message.error(err.msg || err.message || "服务器连接失败");
        });
    },
    //仓库
    //获取仓库数据
    depostInfo() {
      getDepotInfo({ deptId: this.userInfo.deptId }).then((res) => {
        if (res.code == "200") {
          this.depotLst = res.data;
        }
      });
    },

    // 申请单
    async getAppInfo() {
      let params = {
        deptId: this.userInfo.deptId,
        current: this.pageIndex,
        size: this.pageSize,
        ...this.searchForm
      }
      if (this.activeName == 'first') {
        params.states = null
        params.status = this.searchForm.states
      }
      this.List = []
      this.loading = true;
      const res = await this.activeName != 'first' ? await getAppList(params) : await getAppListv2(params)
      const { code, data } = res
      if (code == 200) {
        this.loading = false;
        this.List = data.records;
        this.total = data.total;
      }
    },
    toSearch() {
      this.pageIndex = 1;
      this.getAppInfo();
    },
    reset() {
      this.searchForm.projectName = '';
      this.searchForm.userName = '';
      this.searchForm.states = null;
      this.searchForm.isOverdue = undefined;
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getAppInfo();
    },
    // 刷新
    refresh() {
      this.reload();
    },
    async eqListRefresh() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.eqVisible = false
      await this.getAppInfo();
      loading.close();
    },
    // 出入库记录
    exportInfo(row) {
      let self = this;
      self.exPosp = true;
      self.useId = row.id;
      self.instrumentId = row.insList[0].instrumentId;
      self.deviceType = row.deviceType
    },
    exportInfo2(row) {
      let self = this;
      self.exPospv2 = true;
      self.useId = row.useApplicationId;
      self.instrumentId = row.instrumentId;
    },


    //仪器单
    eqList(row) {
      this.eqData = row.insList;
      this.eqVisible = true;
    },
    async handleClick() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.pageIndex = 1;
      this.searchForm = {
      },
        await this.getAppInfo();
      loading.close();

    },

    //导出使用记录
    derive() {
      this.ruleForm = {}
      this.massExPosp = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;

          let params = {
            ...this.ruleForm
          };

          exAppList(params).then((res) => {
            this.mixin.blobDownload(res.data,'使用记录.xlsx');
            this.loading = false;
            this.massExPosp = false;
          }).catch((err) => {
            console.log(err)
            this.loading = false;
            this.$message.error('没有符合条件的数据可导出');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  computed: {
    highestPort() {
      return window.innerHeight - 310
    },
    roles() {
      // "设备管理员:2" 管理员 1
      return this.$store.state.user.userInfo.roleId
    }
  }
}
</script>

<style lang="less" scoped>
.container_cm {
  width: 100%;
  height: calc(100% - 30px);
  padding: 15px 0;

  .main_cm {
    height: calc(100% - 82px);
    margin: 0 auto;

    .bh_cm {
      height: 20px;
      line-height: 20px;
    }

    .top_cm {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;

      .el-input {
        width: 200px;
        margin: 0 20px;
      }

      .el-button {
        width: 140px;
        margin-left: 20px;
      }

      .el-select {
        margin: 0 20px;
      }
    }

    .table_cm {
      height: 100%;

      /deep/.el-table td {
        font-size: 14px;
      }

      /deep/.el-table__body td {
        padding: 10px 0;
      }

      .box-item-y {
        margin-left: 5px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: red;
        display: inline-block;
      }

      .box-item-n {
        margin-left: 5px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #74c8fe;
        display: inline-block;
      }
    }
  }
}

ul li {
  list-style: none;
}

.right-but {
  display: flex;
  justify-content: right;
}
</style>



// WEBPACK FOOTER //
// src/views/Datamanagement/Applicationmana/index.vue